import _ from 'lodash';
import ObservablePropertyDescriptorObject from '../../utils/ObservablePropertyDescriptorObject';
import PropertyDescriptor from '../../utils/PropertyDescriptor';
import ModelActionProperty from "./ModelActionProperty";

export default class Model extends ObservablePropertyDescriptorObject {

    name = new PropertyDescriptor("", '消息名称', "基本", "string", "#anticon-noun_Soundwave_1786379", {
        description: "需要订阅的消息的名称",
    });

    actions = new PropertyDescriptor([], '动作', "高级", "objects", "#anticon-GroupCopy", {
        description: "消息触发时，执行的动作。当有多个动作时，将从上到下依次执行",
        modelTemplate: ModelActionProperty,
        modelGetter: (opts) => {
            const m = new ModelActionProperty(opts);
            // m._sys.__runScript = this._sys.ui && this._sys.ui.runScript.bind(this._sys.ui);
            return m;
        },
    });

    constructor(opts = {}) {
        super();

        for (var p in opts) {
            this[p].value = opts[p];
        }

        this.defineAllProperties();
    }

    onPropertyValueChanged(name, valOld, valNew, subName, args) {
        this.off();
        this.on();
    }

    on() {
        const designer = this._sys.__designer;
        if (!designer)
            throw new Error("模型中的设计器实例未空，无法订阅消息");

        const name = this.name && this.name.trim();
        if (!name)
            return;

        this._sys.__unsubscribe = designer.registerDataChangedListener(name, obj => {
            this._sys.__runActions(this.actions, obj);
        });
    }

    off() {
        this._sys.__unsubscribe && this._sys.__unsubscribe();
        this._sys.__unsubscribe = null;
    }

    toString() {
        return this.name && {
            svg: `#anticon-noun_Soundwave_1786379`,
            text: `${this.name}`
        } || "<请输入消息名称>";
    }
}
